<template>
  <router-view />
</template>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.loading {
  @keyframes preloader {
    0% {
      transform: scale(0, 0);
      opacity: 0.5;
    }

    100% {
      transform: scale(1, 1);
      opacity: 0;
    }
  }
  span {
    position: absolute;
    display: inline-block;
    width: 50px;
    height: 50px;
    border-radius: 100%;
    background: #f78a74;
    -webkit-animation: preloader 1.3s linear infinite;
    animation: preloader 1.3s linear infinite;
  }
  span:last-child {
    animation-delay: -0.8s;
  }
}

.building {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  font-size: 24px;
  font-weight: 600;
  text-shadow: 4px 4px 0 #dddddd, 6px 6px 0 #eaeaea;
}

.text-left {
  text-align: left;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.flex-row {
  display: flex;
  flex-direction: row;
}
.flex-column {
  display: flex;
  flex-direction: column;
}
.align-content-center {
  align-content: center;
}
.align-content-flex-start {
  align-content: flex-start;
}
.align-content-flex-end {
  align-content: flex-end;
}
.align-content-space-around {
  align-content: space-around;
}
.align-content-space-between {
  align-content: space-between;
}
.align-content-stretch {
  align-content: stretch;
}
.justify-content-center {
  justify-content: center;
}
.justify-content-flex-start {
  justify-content: flex-start;
}
.justify-content-flex-end {
  justify-content: flex-end;
}
.justify-content-space-between {
  justify-content: space-between;
}
.justify-content-space-around {
  justify-content: space-around;
}
.justify-content-space-evenly {
  justify-content: space-evenly;
}
.align-items-center {
  align-items: center;
}
.align-items-flex-start {
  align-items: flex-start;
}
.align-items-flex-end {
  align-items: flex-end;
}
.align-items-stretch {
  align-items: stretch;
}
.align-items-baseline {
  align-items: baseline;
}
.flex-row-center-center {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.flex-column-center-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.margin-0-16 {
  margin: 0 16px;
}

.margin-16-0 {
  margin: 16px 0;
}
</style>
